<template>
	<div class="pt-2">
		<CommonFlame :title="'チェックシート内容'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn @click="$router.push({ name: 'check_sheet_index' })" color="primary">
					<v-icon class="mr-1"> mdi-list-box-outline </v-icon>
					一覧へ戻る
				</v-btn>
				<v-btn
					class="ml-2"
					v-if="checkSheet.issuer_id == $store.getters['auth/authData'].id"
					@click="$router.push({ name: 'check_sheet_edit', params: { id } })"
					color="primary"
				>
					<v-icon class="mr-1"> mdi-pencil </v-icon>
					編集
				</v-btn>
			</template>
			<div>
				<template v-if="approval_authority_flag && checkSheet.status === 'pending'">
					<v-row class="mt-4" no-gutters justify="center">
						<v-alert max-width="600px" outlined type="warning" color="red" prominent>
							<p class="text-body-2 mx-sm-4 mx-2">
								このチェックシートは、<strong>承認待ち</strong>となっています。
								<br />
								承認、または、差し戻しを行ってください。
							</p>
							<v-row class="mt-4" no-gutters justify="space-around">
								<v-btn color="secondary" @click="approveCheckSheet()">
									<v-icon class="mr-1"> mdi-check-circle-outline</v-icon>
									承認
								</v-btn>
								<v-menu v-model="menu" :close-on-content-click="false">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="red" dark v-bind="attrs" v-on="on">
											<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
											差し戻し
										</v-btn>
									</template>

									<v-card width="400px" class="top-border-menu top-border-menu--red">
										<v-form ref="form" v-model="valid" class="pa-2">
											<v-textarea
												class="mt-4"
												v-model="reason"
												label="差し戻し理由"
												:rules="[rules.required]"
												hint="差し戻し理由は作成者へメッセージとして送信されます。"
												outlined
												required
											/>
										</v-form>
										<v-card-actions class="ma-0">
											<v-row no-gutters justify="space-around">
												<v-btn
													color="red"
													:dark="valid"
													@click="rejectCheckSheet()"
													:disabled="!valid"
												>
													<v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
													差し戻し
												</v-btn>
												<v-btn text @click="menu = false"> キャンセル </v-btn>
											</v-row>
										</v-card-actions>
									</v-card>
								</v-menu>
							</v-row>
						</v-alert>
					</v-row>
				</template>

				<v-row no-gutters justify="space-between" class="mt-4">
					<h6 class="text-h6 font-weight-bold">
						{{ checkSheet.name }}
					</h6>
					<v-btn
						v-if="
							$vuetify.breakpoint.xs && checkSheet.issuer_id == $store.getters['auth/authData'].id
						"
						@click="$router.push({ name: 'check_sheet_edit', params: { id } })"
						color="secondary"
					>
						<v-icon class="mr-1"> mdi-pencil </v-icon>
						編集
					</v-btn>
				</v-row>
				<p>製造番号：{{ common.productNumberByOrderIndividualInfo(orderIndividualInfo) }}</p>
				<p>製品名：{{ common.productNameWithSubName(orderIndividualInfo.ordered_product) }}</p>
				<p>台数：{{ orderIndividualInfo.quantity }}</p>
				<p>施工責任者：{{ checkSheet.user ? checkSheet.user.full_name : "未定" }}</p>
				<p>改訂日：{{ common.formatDate(checkSheet.check_sheet_template.updated_at) }}</p>
			</div>
			<div class="table-container mt-4">
				<table class="mt-2" v-for="process in processes" :key="process.id">
					<thead>
						<tr>
							<th rowspan="2">工程</th>
							<th rowspan="2">項目</th>
							<th rowspan="2">方法</th>
							<th rowspan="2">基準</th>
							<template v-for="unit in process.check_units">
								<th class="result-th" :key="`date-${unit.id}`">
									施工日：{{ common.formatDate(unit.check_date) }}
								</th>
								<th class="result-th" rowspan="2" :key="`user-${unit.id}`">確認者</th>
							</template>
						</tr>
						<tr>
							<th class="result-th" v-for="unit in process.check_units" :key="unit.id">
								個数：{{ unit.quantity }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, i) in process.check_process_type.check_items" :key="item.id">
							<td v-if="i == 0" :rowspan="process.check_process_type.check_items.length">
								{{ process.check_process_type.name }}
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
								{{ item.check_method }}
							</td>
							<td>
								{{ item.standard }}
							</td>
							<template v-for="unit in process.check_units">
								<td :key="`value-${unit.id}`">{{ value(unit, item) }}</td>
								<td :key="`user-id-${unit.id}`">{{ unit.user.full_name }}</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			id: this.$route.params.id,
			checkSheet: {
				user: {},
				check_sheet_template: {
					check_items: [],
				},
			},
			orderIndividualInfo: {
				ordered_product: {
					product: {},
				},
				check_processes: [],
			},
			processes: [],
			valid: false,
			menu: false,
			approval_authority_flag: false,
			reason: null,
			common,
			rules,
		}
	},
	mounted() {
		this.fetchCheckSheet()
	},
	methods: {
		fetchCheckSheet() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheets/${this.id}`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					this.checkSheet = res.data.check_sheet
					this.orderIndividualInfo = res.data.order_individual_info
					this.approval_authority_flag = res.data.approval_authority_flag
					this.processes = this.setProcesses()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setProcesses() {
			return this.orderIndividualInfo.check_processes.map((process) => {
				process.check_process_type.check_items =
					this.checkSheet.check_sheet_template.check_items.filter(
						(i) => i.check_process_type_id == process.check_process_type_id
					)
				return process
			})
		},
		approveCheckSheet() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheets/${this.id}/approvals`
			axios
				.post(url, {}, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "チェックシートの発行を承認しました。",
					})
					this.checkSheet.status = res.data.status
					this.checkSheet.status_i18n = res.data.status_i18n
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		rejectCheckSheet() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheets/${this.id}/approvals`
			axios
				.delete(url, { params: { reason: this.reason }, headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "チェックシートの発行を差し戻ししました。",
					})
					this.checkSheet.status_type = res.data.status_type
					this.checkSheet.status_type_i18n = res.data.status_type_i18n
					this.menu = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		value(unit, item) {
			// TODO 確認
			const value = unit.check_values.find((v) => v.check_item_id == item.id)
			return common.value(item, value?.value)
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	th {
		font-weight: bold;
		width: 200px;
		min-width: 200px;
		padding: 4px 8px;
		// background-color: lightgrey;
		background-color: whitesmoke;
		border-bottom: 1px solid white;
		border-right: 1px solid white;
	}
	th.result-th {
		background-color: whitesmoke;
	}
	td {
		width: 200px;
		min-width: 200px;
		padding: 4px;
		border: 1px solid whitesmoke;
		white-space: normal;
		p {
			white-space: pre-wrap;
		}
		p.no-wrap {
			white-space: nowrap;
		}
	}
}
</style>
